import React, { PropsWithChildren, useEffect, useState } from "react";
import { createSafeContext } from "../../hooks/useSafeContext";

export const [useTabsContext, TabsContextProvider] = createSafeContext<{
	activeTab: string | undefined;
	setActiveTab: (value: string) => void;
}>(
	"Tabs component was not found in the tree. You are using a component (TabButton, TabPanel) that requires to be wrapped with a Tabs component.",
);

export const TabsProvider = ({
	children,
	value,
	defaultValue,
}: PropsWithChildren<{
	value?: string;
	defaultValue?: string;
}>) => {
	const [activeTab, setActiveTab] = useState<string | undefined>(defaultValue);

	useEffect(() => {
		if (defaultValue === undefined) {
			setActiveTab(value);
		}
	}, [defaultValue, value]);

	return (
		<TabsContextProvider
			value={{
				activeTab,
				setActiveTab,
			}}
		>
			{children}
		</TabsContextProvider>
	);
};
